import { z } from 'zod'

export const PALETTE = [
  'slate',
  'blue',
  'violet',
  'teal',
  'green',
  'amber',
  'orange',
  'rose',
] as const
export const paletteColorSchema = z.enum(PALETTE)
export type PaletteColor = z.infer<typeof paletteColorSchema>

export const healthResponseSchema = z.object({
  ok: z.boolean(),
  db: z.boolean(),
})
export type HealthResponse = z.infer<typeof healthResponseSchema>

/** Deterministic palette colour for a string (used for avatars). */
export function colorFor(seed: string): PaletteColor {
  let h = 0
  for (let i = 0; i < seed.length; i++) h = (h * 31 + seed.charCodeAt(i)) | 0
  return PALETTE[Math.abs(h) % PALETTE.length] as PaletteColor
}

/** Up to two initials from a display name or email. */
export function initials(name: string): string {
  const base = name.includes('@') ? (name.split('@')[0] ?? '') : name
  const parts = base
    .split(/[\s._-]+/)
    .filter(Boolean)
    .slice(0, 2)
  return parts.map((p) => p[0]?.toUpperCase() ?? '').join('') || '?'
}
